import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/(guest)")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div
      className={
        "relative h-screen w-full overflow-hidden bg-linear-to-br from-gray-50 to-white transition-colors duration-300"
      }
    >
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: `radial-gradient(circle, ${"#0000000d"} 1px, transparent 1px)`,
          backgroundSize: "30px 30px",
        }}
      />

      <div
        className={
          "absolute top-1/4 left-1/4 size-96 animate-pulse rounded-full bg-blue-300 opacity-50 blur-3xl"
        }
      />
      <div
        className={
          "animation-delay-2000 absolute right-1/4 bottom-1/4 size-64 animate-pulse rounded-full bg-green-200 opacity-50 blur-3xl"
        }
      />

      <div className="relative z-10 flex size-full items-center justify-center">
        <Outlet />
      </div>
    </div>
  );
}
